import styled from 'styled-components'
import { styledComponentWithProps } from '../Styled/Shared'
import { hexToRgba } from '../../theme/styled'

type BTProps = {
  selected?: boolean
}

export const SpaceTypeLi = styledComponentWithProps<BTProps>(styled.li)`
  width: 18%;
  height: 170px;
  float: left;
  position: relative;
  cursor: pointer;

  margin: 5px 5px;

  background: ${({ selected, theme }) =>
    selected ? hexToRgba(theme.colors.brand, '.2') : theme.colors.invert};
  border: 1px solid ${({ selected, theme }) =>
    selected ? theme.colors.brand : theme.colors.inactive};

  .contentWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    padding: 15px 20px;
  }

  .pictogram {
    width: 50px;
    height: 50px;
    margin-top: auto;
  }

  .title-line {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .title-line p {
    flex: 1 1 auto;
    text-align: left;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.colors.default};
    font-weight: bold;
    font-size: ${({ theme }) => theme.fonts.defaultSize};
    line-height: 20px;

    span {
      font-weight: normal;
      font-size: 12px;
    }
  }

  h3 {
    padding: 0 10px 10px 10px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.inactive};
    font-size: 30px;
    margin-left: auto;
  }
`
export const InfoTipWrapper = styled.div`
  right: 0;
  margin-left: auto;
  margin-right: 100px;
  position: relative;
`

export const SpaceTypes = styled.ul`
  overflow: visible;
  width: 100%;
  margin: 25px 0;

  &:after {
    content: '';
    flex: auto;
    width: 18%;
  }
`



// WEBPACK FOOTER //
// ./src/Components/SpaceTypeSelect/SpaceTypeStyles.tsx